import _ from "lodash";

export const apiUrl = import.meta.env.VITE_API_URL;
export const root_url = import.meta.env.VITE_ROOT_API;
export const version = import.meta.env.VITE_VERSION;
export const userTokenStorageKey = "APP_USER_TOKEN";
export const authDisabled = false; /* Set to True to disable auth */
export const bridgeAngularJS = false;
export const permanent = true;
export const PermAdminRole = "Administrator";
export const DefaultPermissions = { home: { deny: false } };
export const Debug = import.meta.env.MODE !== "production";
export const BaseURL = import.meta.env.BASE_URL;

export const SentryURL = import.meta.env.VITE_SENTRY_DSN;

export const TurnOnComplexityChecking = false;
export const OldValidationLogic = true;

export const GoBackend = false;
export const JWT_COOKIE_ONLY = true;
export const CheckPageAccess = function (route, currentUser) {
  var result = {};
  if (currentUser && !_.isEmpty(currentUser)) {
    // We are logged in!
    var myGroups = _.keyBy(currentUser.groups, "name");

    if (myGroups["StoreUser"]) {
      // they are in the StoreUser Group
      if (!currentUser.profile.store_id) {
        // they have no store_id!!!
        result = {
          deny: false,
          message:
            "The account you are using has no existing linked Store record. " +
            "Some features might not work. Contact your system administrator for further " +
            "assistance.",
        };
        return result;
      }
    }

    if (currentUser) {
      if ((currentUser.groups || []).length === 0) {
        return {
          deny: true,
          message:
            "This account is not in any groups. " +
            "Contact your system administrator for further " +
            "assistance.",
        };
      }
      if (currentUser.groups.length > 1) {
        return {
          deny: false,
          message:
            "Your login is both a Store and BestFurn user. The system may not work properly",
        };
      }
    }
  }
  return null; // No problem!
};

export const DEFAULT_CODE_LIMIT = 4000;
// Optional settings vue-ocom reads; Vite has no webpack-style undefined for a missing export
export const DisableLocalStorage = false;
export const FlatPickrNoNative = false;
